import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../service/auth.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-email-recover-password',
  templateUrl: './email-recover-password.component.html',
  styleUrls: ['./email-recover-password.component.scss']
})
export class EmailRecoverPasswordComponent implements OnInit {

    formData: FormGroup;
    loading: boolean = false;
    submitted: boolean = false;

    constructor(private fb: FormBuilder, private auth: AuthService) {
        this.formData = this.fb.group({
            'email' : new FormControl('', [Validators.required, Validators.email])
        });
    }

    sendRecoverEmail(): void {

        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.loading = true;
        this.auth.sendEmailRecover(this.formData.value.email).subscribe(
            (result) => {
                (result.hasOwnProperty('error'))
                    ? Swal('Recover pass', result.error, 'error')
                    : Swal('Recover pass', 'We have sent an email to ' + this.formData.value.email + ' with a link to recover your password', 'success')
                ;
                this.loading = false;

            }
        )
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/components/email-recover-password/email-recover-password.component.ts